import { ChevronUp } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowButtonUp1 = mkIcon(ChevronUp);